"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var string_formatters_1 = require("@newfront-insurance/string-formatters");
var utils_1 = require("@newfront-insurance/string-formatters/dist/src/dates/lib/utils");
var react_1 = (0, tslib_1.__importDefault)(require("react"));
var definition_list_1 = require("../definition-list");
var FORMAT_DATE_OPTIONS = { style: string_formatters_1.DateFormatStyle.STANDARD, timezone: utils_1.UTC_TIMEZONE };
function CarrierQuoteDefinitionList(_a) {
    var carrierQuote = _a.carrierQuote;
    var effectiveDate = carrierQuote.coverageEffectiveDate
        ? (0, string_formatters_1.formatDate)(carrierQuote.coverageEffectiveDate, FORMAT_DATE_OPTIONS)
        : 'Unknown';
    var expirationDate = carrierQuote.coverageExpirationDate
        ? (0, string_formatters_1.formatDate)(carrierQuote.coverageExpirationDate, FORMAT_DATE_OPTIONS)
        : 'Unknown';
    var dateDefinition = null;
    if (carrierQuote.coverageEffectiveDate && !carrierQuote.coverageExpirationDate) {
        dateDefinition = {
            type: 'date',
            title: 'Effective date',
            value: "".concat(effectiveDate),
        };
    }
    else if (!carrierQuote.coverageEffectiveDate && carrierQuote.coverageExpirationDate) {
        dateDefinition = {
            type: 'date',
            title: 'Expiration date',
            value: "".concat(expirationDate),
        };
    }
    else if (carrierQuote.coverageEffectiveDate && carrierQuote.coverageExpirationDate) {
        dateDefinition = {
            type: 'dateRange',
            title: 'Effective dates',
            value: "".concat(effectiveDate, " - ").concat(expirationDate),
        };
    }
    return (react_1.default.createElement(definition_list_1.DefinitionList, { items: [
            {
                type: 'document',
                title: 'Lines of coverage',
                value: carrierQuote.linesOfCoverage.join(','),
            },
            dateDefinition,
            {
                type: 'date',
                title: 'Quote expiration date',
                value: (0, string_formatters_1.formatDate)(carrierQuote.quoteExpirationDate, FORMAT_DATE_OPTIONS),
            },
            {
                type: 'currency',
                title: 'Total cost',
                value: carrierQuote.totalCost,
            },
        ].filter(Boolean) }));
}
exports.default = CarrierQuoteDefinitionList;
//# sourceMappingURL=index.js.map